import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetch } from '../store/shownDataSlice';
import ArrangementsTable from '../tables/ArrangementsTable';
import { DataContainer } from '../components/DataContainer';
import Section from '../components/Section';
import { NavLink } from 'react-router-dom';



function Arrangements(props) {
    const dispatch = useDispatch();

    const arrangements = useSelector((state) => state.shownData.arrangements);
    const inactiveArrangements = useSelector((state) => state.shownData.inactiveArrangements);

    useEffect(() => {
        dispatch(fetch.arrangements());
        dispatch(fetch.inactiveArrangements());
    }, []);

    return (
        <div className="column g32 p32">

            <div className="column g16">
                <h1>Regulaarveod</h1>
                <div className="row">
                    <NavLink to="/platform/arrangements/new">Uus regulaarvedu</NavLink>
                </div>
                <Section title="Aktiivsed">
                    <DataContainer actionType={'shownData/fetch/newQueries'}>
                        <ArrangementsTable data={arrangements}/>
                    </DataContainer>
                </Section>

                <Section title="Mitteaktiivsed">
                    <DataContainer actionType={'shownData/fetch/newQueries'}>
                        <ArrangementsTable data={inactiveArrangements}/>
                    </DataContainer>
                </Section>
            </div>
        </div>
    );
};

export default Arrangements;